import React, { useState, useEffect } from 'react';
import cx from 'classnames';

import Button, { ButtonColors } from 'components/Button';

import classes from './CopyButton.module.scss';

let copyTimeOut = null;
const CopyButton = props => {
  const { onClick, className, type = 'outline' } = props;
  const [isCopied, setIsCopied] = useState(false);
  useEffect(() => {
    return () => {
      clearTimeout(copyTimeOut);
      copyTimeOut = null;
    };
  }, []);
  return (
    <Button
      className={cx(classes.copyBtn, className)}
      type={type}
      size="small"
      color={isCopied ? ButtonColors.SECONDARY : ''}
      onClick={() => {
        if (onClick) {
          onClick();
        }
        setIsCopied(true);
        copyTimeOut = setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      }}
    >
      {isCopied ? 'Copied' : 'Copy'}
    </Button>
  );
};

export default CopyButton;
